/* eslint-disable */

import Navigation from '../util/Navigation';

function decodeEntities(encodedString) {
  var textArea = document.createElement('textarea');
  textArea.innerHTML = encodedString;
  return textArea.value;
}

export default {
  init() {

    if ($('.partners').length) {
      $('.partners__slider').slick({
        autoplay: true,
        slidesToShow: 6,
        slidesToScroll: 6,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 5,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
        ],
      });
    }

    let opts = {
      $el: $("#nav-primary"),
      $toggler: $(".navbar-toggler"),
      excludeWatch: ['.btn-contact'],
    };

    let navigation = new Navigation(opts);
    $(window).on('resize', () => navigation.reset());

    $('.wpcf7-radio .wpcf7-list-item > label')
      .unwrap().unwrap().unwrap()
      .addClass('btn btn-secondary')
      .filter(':first')
      .addClass('active');

    $('.wpcf7-acceptance').each(function() {
      let id = Date.now();

      let $parent = $(this).parents('.form-check').first().addClass('wpcf7-acceptance');
      $parent.prepend('<label class="form-check-label" for="'+id+'">'+$(this).find('.wpcf7-list-item-label').text()+'</label>');
      $parent.prepend($(this).find('input').attr('id', id).addClass('form-check-input').detach());
      $parent.find('.wpcf7-form-control-wrap').detach();
    });

    let hashparams = {};
    let hash = window.location.hash.substring(1).split('&');
    for(let param in hash) {
      param = hash[param].split('=');
      hashparams[param[0]] = decodeEntities(decodeURIComponent(param[1]));
    }

    if (hashparams.ref) {
      $('input[name="vehicule_souhaite"]').val(hashparams.ref);
    }

    if (hashparams.from) {
      $('input[name="provenance"]').val(hashparams.from);
    }

    $('.product-gallery__main').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      asNavFor: '.product-gallery__nav',
    });

    $('.product-gallery__nav').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.product-gallery__main',
      dots: false,
      arrows: false,
      focusOnSelect: true,
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js